<div [ngClass]="{'import-block__completed': !isActive() && stepState == ImportStepState.Completed, 'import-block__collapsed': !isActive() && stepState == ImportStepState.Available, 'import-block__not-available': stepState <= ImportStepState.NotAvailableYet, 'loading': dataLoading }"
    class="import-block">
    <div class="d-flex align-items-center">
        <div class="number-circle"><span [ngClass]="{'subtitle-2': stepState !== ImportStepState.Completed, 'material-icons-outlined': (stepState === ImportStepState.Completed && !isActive())}">{{
                (stepState === ImportStepState.Completed && !isActive()) ? 'check' : '9' }}</span></div>
        <h4>Dimensions</h4>
    </div>
    <div *ngIf="isActive()">
        <div class="body-1 mb-8">Select the dimensions to be included in the analysis</div>
        <div #tableContainer class="table-container column-border table-big">
            <!-- Header row -->
            <div class="row header">
                <div *ngFor="let col of columns" class="cell" (click)="toggleSelect(col)"
                    [ngClass]="{'inactive': !col.isEligible, 'selected': col.isSelected, 'invalid': (col.isBad && !col.isSelected)}">
                    <div class="subtitle-2">{{col.name}}</div>
                    <span class="body-2">{{ displayRoughNum(col.uniqueValues) }}</span>
                </div>
            </div>

            <!-- Data rows -->
            <div class="row">
                <div *ngFor="let col of columns" class="cell" [ngClass]="{'inactive': !col.isEligible, 'selected': col.isSelected}">
                    <ng-container *ngIf="col.someVals && col.someVals.length">
                        {{col.someVals[0]}}
                    </ng-container>
                </div>
            </div>
            <div class="row">
                <div *ngFor="let col of columns" class="cell" [ngClass]="{'inactive': !col.isEligible, 'selected': col.isSelected}">
                    <ng-container *ngIf="col.someVals && col.someVals.length > 1">
                        {{col.someVals[1]}}
                    </ng-container>
                </div>
            </div>
            <div class="row">
                <div *ngFor="let col of columns" class="cell" [ngClass]="{'inactive': !col.isEligible, 'selected': col.isSelected}">
                    <ng-container *ngIf="col.someVals && col.someVals.length > 2">
                        {{col.someVals[2]}}
                    </ng-container>
                </div>
            </div>
            <div class="row">
                <div *ngFor="let col of columns" class="cell" [ngClass]="{'inactive': !col.isEligible, 'selected': col.isSelected}">
                    <ng-container *ngIf="col.someVals && col.someVals.length > 3">
                        {{col.someVals[3]}}
                    </ng-container>
                </div>
            </div>
            <div class="row">
                <div *ngFor="let col of columns" class="cell" [ngClass]="{'inactive': !col.isEligible, 'selected': col.isSelected}">
                    <ng-container *ngIf="col.someVals && col.someVals.length > 4">
                        {{col.someVals[4]}}
                    </ng-container>
                </div>
            </div>
            <div class="row">
                <div *ngFor="let col of columns let i = index" [ngClass]="{'selected': col.isSelected}" class="cell ">
                    <a *ngIf="col.isCompacted" (click)="showTopValsDialog(col.name)">Edit Top {{col.compactTopN}}</a>
                </div>
            </div>
        </div>
        <div *ngIf="removeMinNRows" class="text-error mt-8">Your file is too complex: reduce selected dimensions from {{selectedColumnsCount}} to {{selectedColumnsCount - removeMinNRows}} at most.
        </div>
        <div *ngIf="!removeMinNRows && selectedColumnsCount === 0" class="text-error mt-8">Select at least one dimension.
        </div>
    </div>

    <div *ngIf="isActive()">
        <button (click)="save()" [ngClass]="{'loading-small':loading}" [disabled]="selectedColumnsCount === 0" class="btn">Continue</button>
    </div>
    <ng-container *ngIf="!isActive() && stepState == ImportStepState.Completed">
        <div class="d-flex" *ngIf="selectedColumnNames">
            <div class="info-block">
                <span class="body-1">Included in the analysis</span>
                <span class="body-1 text-900">{{ selectedColumnNames }}</span>
            </div>
        </div>
        <div>
            <button (click)="editClick()" class="btn btn-secondary btn-icon btn-edit"><span class="material-icons-outlined">edit</span></button>
        </div>
    </ng-container>
</div>
